import {Component, OnInit} from '@angular/core';
import {HttpService} from "../../services/http/http.service";
import {MatDialog} from "@angular/material/dialog";
import {CommonsService} from "../../services/commons/commons.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DizionarioView} from "../../model/dizionario-view";
import {
  DetailCompetenzaDialog
} from "../../pages/ricerca-profili-competenze/detail-competenze/detail-competenza.component";

@Component({
  selector: 'atlante-competenze',
  templateUrl: './atlante-competenze.component.html',
  styleUrls: ['./atlante-competenze.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({ height: '*', opacity: 1, transform: 'translateY(2)' })),
      state('out', style({ height: '0px', opacity: 0, transform: 'translateY(-10)', overflow: 'hidden' })),
      transition('in => out', animate('300ms ease-in-out')),
      transition('out => in', animate('300ms ease-in-out'))
    ])
  ]
})
export class AtlanteCompetenzeComponent implements OnInit {
  tipoCompetenza: any;
  descrizioneCompetenza: string;
  idTipologiaCompDiBase: number | null;
  tipologieCompetenzaDiBase: any;
  idTipologiaCompDigitale: number | null;
  competenze: any = [];
  competenzeStack: any = [];
  mapCompetenzaIdToAbilita = new Map<number, any[]>();
  mapCompetenzaIdToConoscenza = new Map<number, any[]>();
  fetchedContent = false;
  tipologieCompetenze: DizionarioView[];
  tipologiaCompetenzeDigitali: DizionarioView[];
  isGreen: boolean = false;
  isDigital: boolean = false;

  areeProfessionali: DizionarioView[];
  idAreaProfessionale: number | null;

  constructor(
    public api: HttpService,
    public dialog: MatDialog,
    private readonly commons: CommonsService,
  ) {}

  get limitExceeded(): boolean {
    return this.competenze.length === 150;
  }

  get warningMessageSizeExceeded(): string {
    return "Si richiede di affinare la ricerca inserendo chiavi all'interno del campo competenza";
  }

  get atLeastOneFilterInserted(): boolean {
    return !this.tipoCompetenza && !this.descrizioneCompetenza && !this.isDigital && !this.isGreen;
  }

  get isCompetenzaDiBase(): boolean {
    return this.tipoCompetenza === 3;
  }

  get isDigitalSelectedType(): boolean {
    return this.tipoCompetenza === 6;
  }

  get isCompetenzaIndipendente(): boolean {
    return this.tipoCompetenza === 1;
  }

  ngOnInit(): void {
    this.commons.getTipologiaCompetenza().subscribe({
      next: (response: any) => {
        this.tipologieCompetenze = response.result;
      }
    });

    this.commons.getSottoCategoriaCompetenzaDiBase().subscribe({
      next: (response: any) => {
        this.tipologieCompetenzaDiBase = response.result;
      }
    });

    this.commons.getTipologiaCategoriaDigitale().subscribe({
      next: (response: any) => {
        this.tipologiaCompetenzeDigitali = response.result;
      }
    });

    this.api.getTAreaProfilo().subscribe({
      next: (response: any) => {
        this.areeProfessionali = response.result;
      }
    });

    this.getCompetenze();
  }

  resetSubCategory() {
    this.idTipologiaCompDiBase = null;
    this.idTipologiaCompDigitale = null;
    this.idAreaProfessionale = null;
  }

  emptyCachedData() {
    this.competenzeStack.forEach((el: any) => {
      el.quered = false;
      el.showChild = false;
    });
    this.mapCompetenzaIdToAbilita.clear();
    this.mapCompetenzaIdToConoscenza.clear();
  }

  reset() {
    this.emptyCachedData();
    this.competenze = [...this.competenzeStack];
    this.descrizioneCompetenza = "";
    this.tipoCompetenza = null;
    this.idTipologiaCompDiBase = null;
    this.idTipologiaCompDigitale = null;
    this.idAreaProfessionale = null;
    this.isGreen = false;
    this.isDigital = false;
  }

  onDigitalToggleChange() {
    if (this.isDigital) {
      this.isGreen = false;
    }
    this.filterSearch();
  }

  onGreenToggleChange() {
    if (this.isGreen) {
      this.isDigital = false;
    }

    this.filterSearch();
  }

  getCompetenze() {
    this.fetchedContent = false;
    const { isGreen, isDigital } = this;
    this.commons.getCompetenzeByTipologiaIdAndDescrizione({ hasGreenCompetence: isGreen, hasDigitalCompetence: isDigital }).subscribe({
      next: (response: any) => {
        this.competenze = [...response.result];
        this.competenzeStack = [...response.result];
        this.fetchedContent = true;
      }
    });
  }

  getAbilitaConoscenze(competenza: any) {
    if(competenza.showChild || competenza.quered){
      competenza.showChild = !competenza.showChild;
      return;
    }
    this.commons.getAbilitaByCompetenza(competenza.id).subscribe({
      next: (response: any) => {
        this.mapResult(this.mapCompetenzaIdToAbilita, response.result, competenza.id);
        competenza.showChild = true;
        competenza.quered = true;

      }
    })

    this.commons.getConoscenzeByCompetenza(competenza.id).subscribe({
      next: (response: any) => {
        this.mapResult(this.mapCompetenzaIdToConoscenza, response.result, competenza.id);

        competenza.showChild = true;
        competenza.quered = true;
      }
    })
  }

  mapResult(map: Map<number, any[]>, toMap: any[], mapKey: number) {
    let mapValues = map.get(mapKey);
    if(!mapValues){
      mapValues = [... toMap];
      map.set(mapKey, mapValues);
    }
  }

  filterSearch() {
    this.emptyCachedData();

    const { tipoCompetenza, descrizioneCompetenza, idTipologiaCompDiBase, idTipologiaCompDigitale, isGreen, isDigital, idAreaProfessionale } = this;

    this.commons.getCompetenzeByTipologiaIdAndDescrizione({
      tipoCompetenza,
      descrizioneCompetenza,
      idTipologiaCompDiBase,
      idTipologiaCompDigitale,
      idAreaProfessionale,
      hasGreenCompetence: isGreen,
      hasDigitalCompetence: isDigital
    }).subscribe((response: any) => {
      this.competenze = [...response.result];
    });
  }

  detailCompetenza(el: any) {
    this.dialog.open(DetailCompetenzaDialog, {
      data: { title: "Dettaglio competenza", id: el.id },
      height: '95%',
      width: '100%'
    });

  }

}
